export default __webpack_public_path__ + "static/media/Walk (3).305a3502.png";